<template>
  <div>
    <card class="card">
      <div class="card-body">
        <h2 class="pt-0 mt-0">
          <i class="fas fa-user-cog text-primary"></i>
          {{ $t("user.titleedit") }}
        </h2>
        <hr />
        <div>
          <form @submit.prevent id="userEdit">
            <div class="row" v-if="canManageUsers || isOwnProfile">
              <div class="col-md-12">
                <fg-input
                  type="text"
                  :label="$t('user.name')"
                  name="name"
                  :placeholder="$t('user.name')"
                  v-model="form.name"
                ></fg-input>
              </div>
            </div>
            <div class="row" v-if="canManageUsers || isOwnProfile">
              <div class="col-md-12">
                <fg-input
                  type="email"
                  :label="$t('user.email')"
                  name="email"
                  :placeholder="$t('user.email')"
                  v-model="form.email"
                ></fg-input>
              </div>
            </div>
            <div class="row" v-if="showIfRoleIs('admin-rede,admin')">
              <div class="col-md-12">
                <label class="typo__label">{{ $t("user.asf") }}</label>
                <multiselect
                  v-model="value"
                  :options="asfs"
                  :custom-label="asfLabel"
                  :placeholder="$t('user.text.selectone')"
                  label="name"
                  track-by="id"
                ></multiselect>
              </div>
            </div>
            <div class="row" v-if="canManageUsers">
              <div class="col-md-12">
                <label for="role">{{ $t("user.role") }}</label>
                <div class="form-check" v-if="showIfRoleIs('admin')">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    name="roles[]"
                    v-model="form.role"
                    value="admin"
                    id="admin"
                  />
                  <label for="admin">{{ $t("user.admin") }}</label>
                </div>
                <div
                  class="form-check"
                  v-if="showIfRoleIs('admin-rede,admin') && !$isMainTenant()"
                >
                  <input
                    type="checkbox"
                    class="form-check-input"
                    v-model="form.role"
                    value="admin-rede"
                    id="admin-rede"
                  />
                  <label for="admin-rede">{{ $t("user.redeadmin") }}</label>
                </div>
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    name="roles[]"
                    v-model="form.role"
                    value="asf-admin"
                    id="asf-admin"
                  />
                  <label for="asf-admin">{{ $t("user.asfadmin") }}</label>
                </div>
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    name="roles[]"
                    v-model="form.role"
                    value="asf-frontdesk"
                    id="asf-frontdesk"
                  />
                  <label for="asf-frontdesk">{{
                    $t("user.asffrontdesk")
                  }}</label>
                </div>
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    name="roles[]"
                    v-model="form.role"
                    value="asf-technician"
                    id="asf-technician"
                  />
                  <label for="asf-technician">{{
                    $t("user.asftechnician")
                  }}</label>
                </div>
                <div class="form-check">
                  <input
                    type="checkbox"
                    name="roles[]"
                    class="form-check-input"
                    v-model="form.role"
                    value="client"
                    id="client"
                  />
                  <label for="client">Client</label>
                </div>
              </div>
            </div>
            <div class="text-left">
              <p-button type="primary" @click.native.prevent="updateProfile">{{
                $t("user.button.updateprofile")
              }}</p-button>
            </div>
            <div class="clearfix"></div>
          </form>
        </div>
      </div>
    </card>

    <card class="card" v-if="showIfRoleIs('admin')">
      <div class="card-body">
        <div>
          <h3>{{ $t("user.button.resetpassword") }}</h3>
          <form
            @submit.prevent
            id="userResetPass"
            class="d-flex align-items-center justify-content-between align-items-center"
          >
            <div class="d-flex align-items-center flex-grow-1 mr-2">
              <input
                type="text"
                class="form-control"
                v-model="newPassword"
                disabled
                :placeholder="$t('user.newpassword')"
              />
              <button
                type="button"
                class="btn btn-primary ml-2 d-flex align-items-center"
                @click="copyPassword"
              >
                <i class="fas fa-copy"></i>
              </button>
            </div>
            <p-button
              type="primary"
              class="btn-sm d-flex align-items-center"
              @click.native.prevent="resetPassword"
              >{{ $t("user.button.resetpassword") }}</p-button
            >
          </form>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect
  },
  data() {
    return {
      value: null,
      form: {
        id: null,
        name: "",
        email: "",
        role: [],
        asf: null,
        require_2fa: true
      },
      newPassword: ""
    };
  },
  computed: {
    ...mapState("users", {
      user: "user"
    }),
    ...mapState("asfs", {
      asfs: "all"
    }),
    currentUserId() {
      return this.$store.getters["auth/getUserId"];
    },
    isOwnProfile() {
      return String(this.$route.params.id) === String(this.currentUserId);
    },
    canManageUsers() {
      return this.showIfRoleIs("admin,admin-rede,asf-admin");
    }
  },
  created() {
    this.$store.dispatch("users/getUser", this.$route.params.id);
    if (this.canManageUsers) {
      this.$store.dispatch("asfs/getAllAsfs");
    }
  },
  watch: {
    user: function(newData) {
      if (!newData || newData.id == null) {
        return;
      }
      var asfList = newData.asf;
      this.value = Array.isArray(asfList) && asfList.length ? asfList[0] : null;
      this.form.id = newData.id;
      this.form.name = newData.name || "";
      this.form.email = newData.email || "";
      this.form.role = Array.isArray(newData.role) ? newData.role.slice() : [];
      this.form.asf =
        Array.isArray(asfList) && asfList[0] ? asfList[0].id : null;
      this.form.require_2fa = !!newData.require_2fa;
    },
    value: function(newData) {
      if (
        newData != null &&
        typeof newData === "object" &&
        !Array.isArray(newData) &&
        newData.id != null
      ) {
        this.form.asf = newData.id;
      } else if (newData == null) {
        this.form.asf = null;
      }
    }
  },
  methods: {
    showIfRoleIs(role) {
      return this.$store.getters["auth/isInRoles"](role);
    },
    asfLabel({ name, vat }) {
      return `${name} — ${vat}`;
    },
    updateProfile() {
      // let form = document.getElementById("userEdit");
      // let data = new FormData(form);
      // console.log(JSON.stringify(data));
      // console.log(formElements);
      var payload = this.canManageUsers
        ? this.form
        : {
            id: this.form.id,
            name: this.form.name,
            email: this.form.email
          };

      this.$store
        .dispatch("users/editUser", payload)
        .then(() => {
          if (this.isOwnProfile) {
            this.$store.dispatch("auth/getSessionUser");
          }
          if (this.canManageUsers && !this.isOwnProfile) {
            this.$router.push({ name: "users" });
          }
          this.$notify({
            type: "success",
            message: this.$t("user.message.successupdate")
          });
        })
        .catch(() => {
          if (this.canManageUsers) {
            this.$router.push({ name: "users" });
          }
          this.$notify({
            type: "danger",
            message: "Error! The user data could not be updated."
          });
        });
    },
    async resetPassword() {
      try {
        const response = await this.$store.dispatch(
          "users/resetPass",
          this.form.id
        );
        this.newPassword = response.data.new_pass;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Error! The user data could not be updated."
        });
      }
    },
    copyPassword() {
      navigator.clipboard.writeText(this.newPassword);
      this.$notify({
        type: "success",
        message: this.$t("user.message.copied")
      });
    }
  }
};
</script>
<style></style>
